import { useRef, useCallback } from 'react';
export type InputApi = {
  applyValue: (value: string) => void;
  reset: () => void;
};

export const useInputApi = () => {
  const inputApiRef = useRef<InputApi>();

  const getInputApi = useCallback((api: InputApi) => {
    inputApiRef.current = api;
  }, []);
  return { inputApiRef, getInputApi };
};
